import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/axiosAuth";

export const fetchWholesaleCustomers = createAsyncThunk(
  "api/wholesaleCustomers/fetch",
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`/api/WholesaleCustomers`);
      return { rows: response.data || [] };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const wholesaleCustomersSlice = createSlice({
  name: "wholesaleCustomers",
  initialState: { rows: [], status: "idle", error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWholesaleCustomers.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchWholesaleCustomers.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.rows = action.payload.rows;
      })
      .addCase(fetchWholesaleCustomers.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "حدث خطأ غير متوقع";
      });
  },
});

export default wholesaleCustomersSlice.reducer;
export const selectWholesaleCustomersRows = (state) =>
  state.wholesaleCustomers.rows;
export const selectWholesaleCustomersStatus = (state) =>
  state.wholesaleCustomers.status;
export const selectWholesaleCustomersError = (state) =>
  state.wholesaleCustomers.error;
